module.exports = __webpack_public_path__ + "static/media/QualtricsXM_Step1_Image31.409724bf.jpg";